export default "__VITE_ASSET__DO9i92du__"